/** @format */

import {useContext} from 'react'

import {
  AccountContextType,
  AllFormsContextType,
  FormContextType,
  LoadingContextType,
  ProjectsContextType,
} from '@src/types/contexts'

import {AccountContext} from './AccountContext'
import {AllFormsContext} from './AllFormsContext'
import {FormContext} from './FormContext'
import {LoadingContext} from './LoadingContext'
import {ProjectsContext} from './ProjectsContext'

export function useAccountContext(): AccountContextType {
  return useContext(AccountContext)
}

export function useAllFormsContext(): AllFormsContextType {
  return useContext(AllFormsContext)
}

export function useFormContext(): FormContextType {
  return useContext(FormContext)
}

export function useLoadingContext(): LoadingContextType {
  return useContext(LoadingContext)
}

export function useProjectsContext(): ProjectsContextType {
  return useContext(ProjectsContext)
}

export * from './FormspreeContext'
export * from './PluginContext'
export * from './ProductsContext'
